import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Switch } from "antd";
import { useState } from "react";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormServiceLayout } from "../../../layout.js";
import { FormValueDifferFromTemplateTag } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldGeneralIsEmbeddingOnlyExternalResources = ()=>{
    const { __ } = useI18n();
    const [ref, setRef] = useState();
    const isEmbeddingOnlyExternalResourcesLabel = __("This service does not set any technical cookies on the client of the visitor, but e.g. integrates a script.");
    return /*#__PURE__*/ _jsxs(Form.Item, {
        required: true,
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span,
            span: FormServiceLayout.wrapperCol.span
        },
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "isEmbeddingOnlyExternalResources",
                valuePropName: "checked",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Switch, {})
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "\xa0\xa0",
                    isEmbeddingOnlyExternalResourcesLabel
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    marginTop: 10
                },
                ref: setRef,
                children: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                    form: "service",
                    valueName: "isEmbeddingOnlyExternalResources",
                    widthOfRef: ref,
                    renderDiff: (value)=>/*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Switch, {
                                    disabled: true,
                                    checked: value
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        "\xa0\xa0",
                                        isEmbeddingOnlyExternalResourcesLabel
                                    ]
                                })
                            ]
                        }),
                    noBr: true
                })
            })
        ]
    });
};
export { FormServiceFieldGeneralIsEmbeddingOnlyExternalResources };
